"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm$personDetailNV, _vm$personDetailNV$CA, _vm$personDetailNV2, _vm$personDetailNV2$C, _vm$personDetailPh, _vm$personDetailPh2, _vm$personDetailNV3, _vm$personDetailNV3$C, _vm$personDetailNV4, _vm$personDetailNV4$C, _vm$personDetailPh3, _vm$personDetailPh4, _vm$personDetailNV5, _vm$personDetailNV5$C, _vm$personDetailNV6, _vm$personDetailNV6$C, _vm$personDetailNV7, _vm$personDetailNV7$P, _vm$personDetailNV8, _vm$personDetailNV8$P, _vm$personDetailNV9, _vm$personDetailNV9$C, _vm$personDetailNV0, _vm$personDetailNV0$C, _vm$personDetailArPn, _vm$personDetailArPn2, _vm$personDetailNV1, _vm$personDetailNV1$C, _vm$personDetailNV10, _vm$personDetailNV10$, _vm$personDetailNV11, _vm$personDetailNV11$, _vm$personDetailNV12, _vm$personDetailNV13, _vm$personDetailNV13$, _vm$personDetailPh5, _vm$personDetailPh6, _vm$personDetailPh6$A, _vm$personDetailNV14, _vm$personDetailNV15, _vm$personDetailNV15$, _vm$personDetailPh7, _vm$personDetailPh8, _vm$personDetailPh8$P, _vm$personDetailPh9, _vm$personDetailPh9$E, _vm$personDetailPh0, _vm$personDetailPh0$E, _vm$personDetailNV16, _vm$personDetailNV16$, _vm$personDetailNV17, _vm$personDetailNV17$, _vm$personDetailNV18, _vm$personDetailNV18$, _vm$personDetailNV19, _vm$personDetailNV19$, _vm$personDetailPh1, _vm$personDetailPh1$I, _vm$personDetailPh10, _vm$personDetailPh10$, _vm$personDetailNV20, _vm$personDetailNV20$, _vm$personDetailNV21, _vm$personDetailNV21$, _vm$personDetailNV22, _vm$personDetailNV22$, _vm$personDetailNV23, _vm$personDetailNV23$, _vm$personDetailNV24, _vm$personDetailNV24$, _vm$personDetailNV25, _vm$personDetailNV25$, _vm$personDetailNV26, _vm$personDetailNV26$, _vm$personDetailNV27, _vm$personDetailNV27$, _vm$personDetailNV28, _vm$personDetailNV28$, _vm$personDetailNV29, _vm$personDetailNV29$, _vm$personDetailNV30, _vm$personDetailNV30$, _vm$personDetailNV31, _vm$personDetailNV31$, _vm$personDetailNV32, _vm$personDetailNV32$, _vm$personDetailNV34, _vm$personDetailNV34$, _vm$personDetailNV35, _vm$personDetailNV35$, _vm$personDetailNV36, _vm$personDetailNV36$, _vm$personDetailPh11, _vm$personDetailPh11$, _vm$personDetailPh12, _vm$personDetailPh12$, _vm$personDetailNV37, _vm$personDetailNV37$, _vm$personDetailNV38, _vm$personDetailNV38$, _vm$personDetailNV39, _vm$personDetailNV39$, _vm$personDetailNV40, _vm$personDetailNV40$, _vm$personDetailNV41, _vm$personDetailNV41$, _vm$personDetailNV42, _vm$personDetailNV42$, _vm$personDetailNV43, _vm$personDetailNV43$, _vm$personDetailNV44, _vm$personDetailNV44$, _vm$personDetailNV45, _vm$personDetailNV45$, _vm$personDetailNV46, _vm$personDetailNV46$, _vm$personDetailPh13, _vm$personDetailPh14, _vm$personDetailPh14$, _vm$personDetailPh15, _vm$personDetailPh16, _vm$personDetailPh17, _vm$personDetailPh18, _vm$personDetailNV47, _vm$personDetailNV47$, _vm$personDetailNV48, _vm$personDetailNV48$, _vm$personDetailNV49, _vm$personDetailNV49$, _vm$personDetailNV50, _vm$personDetailNV50$, _vm$personDetailNV51, _vm$personDetailNV51$, _vm$personDetailArPn3, _vm$personDetailArPn4;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-pro-det"
  }, [_c("div", {
    staticClass: "header-items"
  }, [_c("h5", {
    staticClass: "grid-h title-page"
  }, [_c("button", {
    attrs: {
      nbButton: ""
    },
    on: {
      click: _vm.goBack
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "arrow-left"
    }
  })], 1), _vm._v("\n      Análise Pessoal\n    ")])]), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column col-detail-details"
  }, [_vm.errorN || _vm.errorP || _vm.erroArPn ? _c("b-message", {
    attrs: {
      title: "Aviso",
      type: "is-warning",
      "aria-close-label": "Fechar mensagem"
    }
  }, [_vm._v("\n        Os dados para esse CPF não foram retornados pelo provedor.\n      ")]) : _vm._e(), _vm._v(" "), _c("b-collapse", {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentPersonalData",
      animation: "slide"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn() {
        return [_c("div", {
          staticClass: "panel-heading",
          attrs: {
            role: "button",
            "aria-controls": "contentPersonalData"
          }
        }, [_c("strong", [_vm._v("Dados Pessoais")])])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c("div", {
    staticClass: "content-data"
  }, [_c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV = _vm.personDetailNV) !== null && _vm$personDetailNV !== void 0 && (_vm$personDetailNV$CA = _vm$personDetailNV.CADASTRAIS) !== null && _vm$personDetailNV$CA !== void 0 && _vm$personDetailNV$CA.NOME ? _c("b-field", {
    attrs: {
      label: "NOME (NovaVida)",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailNV2 = _vm.personDetailNV) === null || _vm$personDetailNV2 === void 0 ? void 0 : (_vm$personDetailNV2$C = _vm$personDetailNV2.CADASTRAIS) === null || _vm$personDetailNV2$C === void 0 ? void 0 : _vm$personDetailNV2$C.NOME,
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailPh = _vm.personDetailPh) !== null && _vm$personDetailPh !== void 0 && _vm$personDetailPh.NameBrasil ? _c("b-field", {
    attrs: {
      label: "NOME (PH3A)",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailPh2 = _vm.personDetailPh) === null || _vm$personDetailPh2 === void 0 ? void 0 : _vm$personDetailPh2.NameBrasil,
      disabled: ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV3 = _vm.personDetailNV) !== null && _vm$personDetailNV3 !== void 0 && (_vm$personDetailNV3$C = _vm$personDetailNV3.CADASTRAIS) !== null && _vm$personDetailNV3$C !== void 0 && _vm$personDetailNV3$C.NASC ? _c("b-field", {
    attrs: {
      label: "Dt. Nascimento (NovaVida)"
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailNV4 = _vm.personDetailNV) === null || _vm$personDetailNV4 === void 0 ? void 0 : (_vm$personDetailNV4$C = _vm$personDetailNV4.CADASTRAIS) === null || _vm$personDetailNV4$C === void 0 ? void 0 : _vm$personDetailNV4$C.NASC,
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailPh3 = _vm.personDetailPh) !== null && _vm$personDetailPh3 !== void 0 && _vm$personDetailPh3.BirthDate ? _c("b-field", {
    attrs: {
      label: "Dt. Nascimento (PH3A)"
    }
  }, [_c("b-input", {
    attrs: {
      value: _vm._f("dateFormat")((_vm$personDetailPh4 = _vm.personDetailPh) === null || _vm$personDetailPh4 === void 0 ? void 0 : _vm$personDetailPh4.BirthDate),
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV5 = _vm.personDetailNV) !== null && _vm$personDetailNV5 !== void 0 && (_vm$personDetailNV5$C = _vm$personDetailNV5.CADASTRAIS) !== null && _vm$personDetailNV5$C !== void 0 && _vm$personDetailNV5$C.ESTADOCIVIL ? _c("b-field", {
    attrs: {
      label: "ESTADO CIVIL",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailNV6 = _vm.personDetailNV) === null || _vm$personDetailNV6 === void 0 ? void 0 : (_vm$personDetailNV6$C = _vm$personDetailNV6.CADASTRAIS) === null || _vm$personDetailNV6$C === void 0 ? void 0 : _vm$personDetailNV6$C.ESTADOCIVIL,
      disabled: ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_vm.deathIndication ? _c("b-field", {
    attrs: {
      label: "INDICAÇÃO DE ÓBITO"
    }
  }, [_c("b-input", {
    attrs: {
      value: _vm.deathIndication,
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV7 = _vm.personDetailNV) !== null && _vm$personDetailNV7 !== void 0 && (_vm$personDetailNV7$P = _vm$personDetailNV7.PEP) !== null && _vm$personDetailNV7$P !== void 0 && _vm$personDetailNV7$P.FLPEP ? _c("b-field", {
    attrs: {
      label: "PEP"
    }
  }, [_c("b-input", {
    attrs: {
      value: ((_vm$personDetailNV8 = _vm.personDetailNV) === null || _vm$personDetailNV8 === void 0 ? void 0 : (_vm$personDetailNV8$P = _vm$personDetailNV8.PEP) === null || _vm$personDetailNV8$P === void 0 ? void 0 : _vm$personDetailNV8$P.FLPEP) === "S" ? "SIM" : "NÃO",
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV9 = _vm.personDetailNV) !== null && _vm$personDetailNV9 !== void 0 && (_vm$personDetailNV9$C = _vm$personDetailNV9.CADASTRAIS) !== null && _vm$personDetailNV9$C !== void 0 && _vm$personDetailNV9$C.POSSIVELESCOLARIDADE ? _c("b-field", {
    attrs: {
      label: "ESCOLARIDADE",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailNV0 = _vm.personDetailNV) === null || _vm$personDetailNV0 === void 0 ? void 0 : (_vm$personDetailNV0$C = _vm$personDetailNV0.CADASTRAIS) === null || _vm$personDetailNV0$C === void 0 ? void 0 : _vm$personDetailNV0$C.POSSIVELESCOLARIDADE,
      disabled: ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailArPn = _vm.personDetailArPn) !== null && _vm$personDetailArPn !== void 0 && _vm$personDetailArPn.descricao ? _c("b-field", {
    attrs: {
      label: "DESCRIÇÃO DE ÓBITO",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailArPn2 = _vm.personDetailArPn) === null || _vm$personDetailArPn2 === void 0 ? void 0 : _vm$personDetailArPn2.descricao,
      disabled: ""
    }
  })], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _vm.hasAlivecheckData ? _c("b-collapse", {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentPersonalAlivecheck",
      animation: "slide"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn() {
        return [_c("div", {
          staticClass: "panel-heading",
          attrs: {
            role: "button",
            "aria-controls": "contentPersonalAlivecheck"
          }
        }, [_c("strong", [_vm._v("Informações de Óbito")])])];
      },
      proxy: true
    }], null, false, 3856110066)
  }, [_vm._v(" "), _c("div", {
    staticClass: "content-data"
  }, [_vm._l(_vm.alivecheckFieldRows, function (row, rowIndex) {
    return _c("b-field", {
      key: rowIndex,
      attrs: {
        grouped: ""
      }
    }, _vm._l(row, function (field) {
      return _c("b-field", {
        key: field.key,
        attrs: {
          label: field.label,
          expanded: ""
        }
      }, [_c("b-input", {
        attrs: {
          value: field.value,
          disabled: ""
        }
      })], 1);
    }), 1);
  }), _vm._v(" "), _vm.alivecheckDescription ? _c("b-field", {
    attrs: {
      label: _vm.alivecheckDescription.label,
      expanded: ""
    }
  }, [_c("div", {
    staticClass: "control is-expanded"
  }, [_c("div", {
    staticClass: "alivecheck-description",
    attrs: {
      role: "textbox",
      "aria-readonly": "true"
    },
    domProps: {
      textContent: _vm._s(_vm.alivecheckDescription.value)
    }
  })])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm.hasAddressNV ? _c("b-collapse", {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentPersonalAddress",
      animation: "slide"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn() {
        return [_c("div", {
          staticClass: "panel-heading",
          attrs: {
            role: "button",
            "aria-controls": "contentPersonalAddress"
          }
        }, [_c("strong", [_vm._v("Endereços Nova Vida")])])];
      },
      proxy: true
    }], null, false, 2979567337)
  }, [_vm._v(" "), _c("div", {
    staticClass: "content-data"
  }, [_c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV1 = _vm.personDetailNV) !== null && _vm$personDetailNV1 !== void 0 && (_vm$personDetailNV1$C = _vm$personDetailNV1.CADASTRAIS) !== null && _vm$personDetailNV1$C !== void 0 && _vm$personDetailNV1$C.FLAG_AGLOMERADO_SUBNORMAL ? _c("b-field", {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v("\n                AGLOMERADO SUBNORMAL\n                "), _c("b-tooltip", {
          attrs: {
            type: "is-primary is-light",
            label: "Aglomerado Subnormal é uma forma de ocupação irregular de terrenos de propriedade alheia, informação do primeiro endereço do usuário!",
            multilined: ""
          }
        }, [_c("b-icon", {
          attrs: {
            size: "is-small",
            icon: "help-circle-outline"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 196082461)
  }, [_vm._v(" "), (_vm$personDetailNV10 = _vm.personDetailNV) !== null && _vm$personDetailNV10 !== void 0 && (_vm$personDetailNV10$ = _vm$personDetailNV10.CADASTRAIS) !== null && _vm$personDetailNV10$ !== void 0 && _vm$personDetailNV10$.FLAG_AGLOMERADO_SUBNORMAL ? _c("b-input", {
    attrs: {
      value: ((_vm$personDetailNV11 = _vm.personDetailNV) === null || _vm$personDetailNV11 === void 0 ? void 0 : (_vm$personDetailNV11$ = _vm$personDetailNV11.CADASTRAIS) === null || _vm$personDetailNV11$ === void 0 ? void 0 : _vm$personDetailNV11$.FLAG_AGLOMERADO_SUBNORMAL) === "S" ? "SIM" : "NÃO",
      disabled: ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm$personDetailNV12 = _vm.personDetailNV) !== null && _vm$personDetailNV12 !== void 0 && _vm$personDetailNV12.ENDERECOS ? [_c("b-field", {
    staticClass: "divider",
    attrs: {
      label: "Endereços:"
    }
  }), _vm._v(" "), _c("div", _vm._l((_vm$personDetailNV13 = _vm.personDetailNV) === null || _vm$personDetailNV13 === void 0 ? void 0 : (_vm$personDetailNV13$ = _vm$personDetailNV13.ENDERECOS) === null || _vm$personDetailNV13$ === void 0 ? void 0 : _vm$personDetailNV13$.slice(0, 3), function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "content-address"
    }, [_c("b-field", {
      attrs: {
        label: "LOGRADOURO",
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: _vm.formatAddress(item),
        disabled: ""
      }
    })], 1)], 1);
  }), 0)] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm.hasAddressPH ? _c("b-collapse", {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentPersonalAddressPH",
      animation: "slide"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn() {
        return [_c("div", {
          staticClass: "panel-heading",
          attrs: {
            role: "button",
            "aria-controls": "contentPersonalAddressPH"
          }
        }, [_c("strong", [_vm._v("Endereços PH3A")])])];
      },
      proxy: true
    }], null, false, 3212470135)
  }, [_vm._v(" "), (_vm$personDetailPh5 = _vm.personDetailPh) !== null && _vm$personDetailPh5 !== void 0 && _vm$personDetailPh5.Addresses ? _c("div", {
    staticClass: "content-data"
  }, [_c("b-field", {
    staticClass: "divider",
    attrs: {
      label: "Endereços:"
    }
  }), _vm._v(" "), _vm._l((_vm$personDetailPh6 = _vm.personDetailPh) === null || _vm$personDetailPh6 === void 0 ? void 0 : (_vm$personDetailPh6$A = _vm$personDetailPh6.Addresses) === null || _vm$personDetailPh6$A === void 0 ? void 0 : _vm$personDetailPh6$A.slice(0, 3), function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "content-address"
    }, [_c("b-field", {
      attrs: {
        grouped: ""
      }
    }, [_c("b-field", {
      attrs: {
        label: "LOGRADOURO",
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: item.Alias,
        disabled: ""
      }
    })], 1), _vm._v(" "), _c("b-field", {
      scopedSlots: _vm._u([{
        key: "label",
        fn: function fn() {
          return [_vm._v("\n                  SCORE\n                  "), _c("b-tooltip", {
            attrs: {
              type: "is-primary is-light",
              label: "Valor da 0 a 10, sendo 10 a maior probabilidade do usuário residir neste endereço!",
              multilined: ""
            }
          }, [_c("b-icon", {
            attrs: {
              size: "is-small",
              icon: "help-circle-outline"
            }
          })], 1)];
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c("b-input", {
      attrs: {
        value: item.Score,
        disabled: ""
      }
    })], 1)], 1)], 1);
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.hasContactInfos ? _c("b-collapse", {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentPersonalContacts",
      animation: "slide"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn() {
        return [_c("div", {
          staticClass: "panel-heading",
          attrs: {
            role: "button",
            "aria-controls": "contentPersonalContacts"
          }
        }, [_c("strong", [_vm._v("Dados de Contato")])])];
      },
      proxy: true
    }], null, false, 903878006)
  }, [_vm._v(" "), _c("div", {
    staticClass: "content-data"
  }, [(_vm$personDetailNV14 = _vm.personDetailNV) !== null && _vm$personDetailNV14 !== void 0 && _vm$personDetailNV14.TELEFONES ? [_c("b-field", {
    staticClass: "divider",
    attrs: {
      label: "Telefones NovaVida:"
    }
  }), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, _vm._l((_vm$personDetailNV15 = _vm.personDetailNV) === null || _vm$personDetailNV15 === void 0 ? void 0 : (_vm$personDetailNV15$ = _vm$personDetailNV15.TELEFONES) === null || _vm$personDetailNV15$ === void 0 ? void 0 : _vm$personDetailNV15$.slice(0, 3), function (item, idx) {
    return _c("b-field", {
      key: idx,
      class: {
        "show-contrast": _vm.verifyPhoneExistPH(_vm.formatPhone(item))
      },
      attrs: {
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: "".concat(_vm.formatPhone(item), " ").concat(item.ASSINANTE === "S" ? "- Proprietário" : ""),
        disabled: ""
      }
    })], 1);
  }), 1)] : _vm._e(), _vm._v(" "), (_vm$personDetailPh7 = _vm.personDetailPh) !== null && _vm$personDetailPh7 !== void 0 && _vm$personDetailPh7.Phones ? [_c("b-field", {
    staticClass: "divider",
    attrs: {
      label: "Telefones PH3A:"
    }
  }), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, _vm._l((_vm$personDetailPh8 = _vm.personDetailPh) === null || _vm$personDetailPh8 === void 0 ? void 0 : (_vm$personDetailPh8$P = _vm$personDetailPh8.Phones) === null || _vm$personDetailPh8$P === void 0 ? void 0 : _vm$personDetailPh8$P.slice(0, 3), function (item, idx) {
    return _c("b-field", {
      key: idx,
      class: {
        "show-contrast": _vm.verifyPhoneExistNV(item.FormattedNumber)
      },
      attrs: {
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: item.FormattedNumber,
        disabled: ""
      }
    })], 1);
  }), 1)] : _vm._e(), _vm._v(" "), _vm.emailsNV.length ? [_c("b-field", {
    staticClass: "divider",
    attrs: {
      label: "E-mails NovaVida:"
    }
  }), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, _vm._l(_vm.emailsNV, function (item, idx) {
    return _c("b-field", {
      key: idx,
      class: {
        "show-contrast": _vm.verifyEmailExistPH(item.EMAIL)
      },
      attrs: {
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: item.EMAIL,
        disabled: ""
      }
    })], 1);
  }), 1)] : _vm._e(), _vm._v(" "), (_vm$personDetailPh9 = _vm.personDetailPh) !== null && _vm$personDetailPh9 !== void 0 && (_vm$personDetailPh9$E = _vm$personDetailPh9.Emails) !== null && _vm$personDetailPh9$E !== void 0 && _vm$personDetailPh9$E.length ? [_c("b-field", {
    staticClass: "divider",
    attrs: {
      label: "E-mails PH3A:"
    }
  }), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, _vm._l((_vm$personDetailPh0 = _vm.personDetailPh) === null || _vm$personDetailPh0 === void 0 ? void 0 : (_vm$personDetailPh0$E = _vm$personDetailPh0.Emails) === null || _vm$personDetailPh0$E === void 0 ? void 0 : _vm$personDetailPh0$E.slice(0, 3), function (item, idx) {
    return _c("b-field", {
      key: idx,
      class: {
        "show-contrast": _vm.verifyEmailExistNV(item.Email)
      },
      attrs: {
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: item.Email,
        disabled: ""
      }
    })], 1);
  }), 1)] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm.hasProfissionalData ? _c("b-collapse", {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentPersonalProfessional",
      animation: "slide"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn() {
        return [_c("div", {
          staticClass: "panel-heading",
          attrs: {
            role: "button",
            "aria-controls": "contentPersonalProfessional"
          }
        }, [_c("strong", [_vm._v("Dados Profissionais")])])];
      },
      proxy: true
    }], null, false, 78089458)
  }, [_vm._v(" "), _c("div", {
    staticClass: "content-data"
  }, [_c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV16 = _vm.personDetailNV) !== null && _vm$personDetailNV16 !== void 0 && (_vm$personDetailNV16$ = _vm$personDetailNV16.CADASTRAIS) !== null && _vm$personDetailNV16$ !== void 0 && _vm$personDetailNV16$.POSSIVELPROFISSAO ? _c("b-field", {
    attrs: {
      label: "PROFISSÃO (NovaVida)",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailNV17 = _vm.personDetailNV) === null || _vm$personDetailNV17 === void 0 ? void 0 : (_vm$personDetailNV17$ = _vm$personDetailNV17.CADASTRAIS) === null || _vm$personDetailNV17$ === void 0 ? void 0 : _vm$personDetailNV17$.POSSIVELPROFISSAO,
      disabled: ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV18 = _vm.personDetailNV) !== null && _vm$personDetailNV18 !== void 0 && (_vm$personDetailNV18$ = _vm$personDetailNV18.CADASTRAIS) !== null && _vm$personDetailNV18$ !== void 0 && _vm$personDetailNV18$.RENDA ? _c("b-field", {
    attrs: {
      label: "RENDA PRESUMIDA (NovaVida)"
    }
  }, [_c("b-input", {
    attrs: {
      value: _vm._f("maskMoney")((_vm$personDetailNV19 = _vm.personDetailNV) === null || _vm$personDetailNV19 === void 0 ? void 0 : (_vm$personDetailNV19$ = _vm$personDetailNV19.CADASTRAIS) === null || _vm$personDetailNV19$ === void 0 ? void 0 : _vm$personDetailNV19$.RENDA),
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailPh1 = _vm.personDetailPh) !== null && _vm$personDetailPh1 !== void 0 && (_vm$personDetailPh1$I = _vm$personDetailPh1.Income) !== null && _vm$personDetailPh1$I !== void 0 && _vm$personDetailPh1$I.Presumed ? _c("b-field", {
    attrs: {
      label: "RENDA PRESUMIDA (PH3A)"
    }
  }, [_c("b-input", {
    attrs: {
      value: _vm._f("maskMoney")((_vm$personDetailPh10 = _vm.personDetailPh) === null || _vm$personDetailPh10 === void 0 ? void 0 : (_vm$personDetailPh10$ = _vm$personDetailPh10.Income) === null || _vm$personDetailPh10$ === void 0 ? void 0 : _vm$personDetailPh10$.Presumed),
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV20 = _vm.personDetailNV) !== null && _vm$personDetailNV20 !== void 0 && (_vm$personDetailNV20$ = _vm$personDetailNV20.CADASTRAIS) !== null && _vm$personDetailNV20$ !== void 0 && _vm$personDetailNV20$.FONTE_DE_RENDA ? _c("b-field", {
    attrs: {
      label: "FONTE DE RENDA (NovaVida)",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailNV21 = _vm.personDetailNV) === null || _vm$personDetailNV21 === void 0 ? void 0 : (_vm$personDetailNV21$ = _vm$personDetailNV21.CADASTRAIS) === null || _vm$personDetailNV21$ === void 0 ? void 0 : _vm$personDetailNV21$.FONTE_DE_RENDA,
      disabled: ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV22 = _vm.personDetailNV) !== null && _vm$personDetailNV22 !== void 0 && (_vm$personDetailNV22$ = _vm$personDetailNV22.CADASTRAIS) !== null && _vm$personDetailNV22$ !== void 0 && _vm$personDetailNV22$.CLASSEECONOMICA ? _c("b-field", {
    attrs: {
      label: "CLASSE ECONÔMICA",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailNV23 = _vm.personDetailNV) === null || _vm$personDetailNV23 === void 0 ? void 0 : (_vm$personDetailNV23$ = _vm$personDetailNV23.CADASTRAIS) === null || _vm$personDetailNV23$ === void 0 ? void 0 : _vm$personDetailNV23$.CLASSEECONOMICA,
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV24 = _vm.personDetailNV) !== null && _vm$personDetailNV24 !== void 0 && (_vm$personDetailNV24$ = _vm$personDetailNV24.CADASTRAIS) !== null && _vm$personDetailNV24$ !== void 0 && _vm$personDetailNV24$.AUXILIOBRASIL ? _c("b-field", {
    attrs: {
      label: "AUXÍLIO BRASIL",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: ((_vm$personDetailNV25 = _vm.personDetailNV) === null || _vm$personDetailNV25 === void 0 ? void 0 : (_vm$personDetailNV25$ = _vm$personDetailNV25.CADASTRAIS) === null || _vm$personDetailNV25$ === void 0 ? void 0 : _vm$personDetailNV25$.AUXILIOBRASIL) === "N" ? "NÃO" : "SIM",
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV26 = _vm.personDetailNV) !== null && _vm$personDetailNV26 !== void 0 && (_vm$personDetailNV26$ = _vm$personDetailNV26.CADASTRAIS) !== null && _vm$personDetailNV26$ !== void 0 && _vm$personDetailNV26$.TEMPO_EMPREENDEDOR ? _c("b-field", {
    attrs: {
      label: "TEMPO NO ÚLTIMO TRABALHO",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: "".concat((_vm$personDetailNV27 = _vm.personDetailNV) === null || _vm$personDetailNV27 === void 0 ? void 0 : (_vm$personDetailNV27$ = _vm$personDetailNV27.CADASTRAIS) === null || _vm$personDetailNV27$ === void 0 ? void 0 : _vm$personDetailNV27$.TEMPO_EMPREENDEDOR, " anos"),
      disabled: ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV28 = _vm.personDetailNV) !== null && _vm$personDetailNV28 !== void 0 && (_vm$personDetailNV28$ = _vm$personDetailNV28.PERFILCONSUMO) !== null && _vm$personDetailNV28$ !== void 0 && _vm$personDetailNV28$.POSSIVEL_APOSENTADO ? _c("b-field", {
    attrs: {
      label: "POSSÍVEL APOSENTADO",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: ((_vm$personDetailNV29 = _vm.personDetailNV) === null || _vm$personDetailNV29 === void 0 ? void 0 : (_vm$personDetailNV29$ = _vm$personDetailNV29.PERFILCONSUMO) === null || _vm$personDetailNV29$ === void 0 ? void 0 : _vm$personDetailNV29$.POSSIVEL_APOSENTADO) === "N" ? "NÃO" : "SIM",
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV30 = _vm.personDetailNV) !== null && _vm$personDetailNV30 !== void 0 && (_vm$personDetailNV30$ = _vm$personDetailNV30.FGTS) !== null && _vm$personDetailNV30$ !== void 0 && _vm$personDetailNV30$.VLR_PRESUMIDO ? _c("b-field", {
    attrs: {
      label: "SALDO PRESUMIDO DO FGTS",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: _vm._f("maskMoney")((_vm$personDetailNV31 = _vm.personDetailNV) === null || _vm$personDetailNV31 === void 0 ? void 0 : (_vm$personDetailNV31$ = _vm$personDetailNV31.FGTS) === null || _vm$personDetailNV31$ === void 0 ? void 0 : _vm$personDetailNV31$.VLR_PRESUMIDO),
      disabled: ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _vm.professionalData.length ? [_c("b-field", {
    staticClass: "divider",
    attrs: {
      label: "HISTÓRICO DE EMPREGOS:"
    }
  }), _vm._v(" "), _vm._l(_vm.professionalData, function (item, idx) {
    var _item$Company;
    return _c("div", {
      key: idx,
      staticClass: "content-address"
    }, [_c("b-field", {
      attrs: {
        grouped: ""
      }
    }, [_c("b-field", {
      attrs: {
        label: "NOME DA EMPRESA",
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: item === null || item === void 0 ? void 0 : (_item$Company = item.Company) === null || _item$Company === void 0 ? void 0 : _item$Company.Name,
        disabled: ""
      }
    })], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "DATA DE ADMISSÃO"
      }
    }, [_c("b-input", {
      attrs: {
        value: _vm._f("dateFormat")(item === null || item === void 0 ? void 0 : item.CreateDate),
        disabled: ""
      }
    })], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "DATA DE DEMISSÃO"
      }
    }, [_c("b-input", {
      attrs: {
        value: _vm._f("dateFormat")(item === null || item === void 0 ? void 0 : item.DemissionDate),
        disabled: ""
      }
    })], 1)], 1)], 1);
  })] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm.hasCreditData ? _c("b-collapse", {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentPersonalCredit",
      animation: "slide"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn() {
        return [_c("div", {
          staticClass: "panel-heading",
          attrs: {
            role: "button",
            "aria-controls": "contentPersonalCredit"
          }
        }, [_c("strong", [_vm._v("Dados de Crédito")])])];
      },
      proxy: true
    }], null, false, 3933619946)
  }, [_vm._v(" "), _c("div", {
    staticClass: "content-data"
  }, [_c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV32 = _vm.personDetailNV) !== null && _vm$personDetailNV32 !== void 0 && (_vm$personDetailNV32$ = _vm$personDetailNV32.CADASTRAIS) !== null && _vm$personDetailNV32$ !== void 0 && _vm$personDetailNV32$.PERSONACREDITO ? _c("b-field", {
    attrs: {
      expanded: ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        var _vm$personDetailNV33, _vm$personDetailNV33$;
        return [_vm._v("\n                PERSONA\n                "), _c("b-tooltip", {
          attrs: {
            type: "is-primary is-light",
            label: "Vari\xE1vel de cr\xE9dito com uma vis\xE3o presumida de como o usu\xE1rio se comporta. (".concat(_vm.descriptionPersonCredit((_vm$personDetailNV33 = _vm.personDetailNV) === null || _vm$personDetailNV33 === void 0 ? void 0 : (_vm$personDetailNV33$ = _vm$personDetailNV33.CADASTRAIS) === null || _vm$personDetailNV33$ === void 0 ? void 0 : _vm$personDetailNV33$.PERSONACREDITO), ")"),
            multilined: ""
          }
        }, [_c("b-icon", {
          attrs: {
            size: "is-small",
            icon: "help-circle-outline"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 932676138)
  }, [_vm._v(" "), _c("b-input", {
    attrs: {
      value: (_vm$personDetailNV34 = _vm.personDetailNV) === null || _vm$personDetailNV34 === void 0 ? void 0 : (_vm$personDetailNV34$ = _vm$personDetailNV34.CADASTRAIS) === null || _vm$personDetailNV34$ === void 0 ? void 0 : _vm$personDetailNV34$.PERSONACREDITO,
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV35 = _vm.personDetailNV) !== null && _vm$personDetailNV35 !== void 0 && (_vm$personDetailNV35$ = _vm$personDetailNV35.CADASTRAIS) !== null && _vm$personDetailNV35$ !== void 0 && _vm$personDetailNV35$.SCORE ? _c("b-field", {
    attrs: {
      label: ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v("\n                SCORE (NovaVida)\n                "), _c("b-tooltip", {
          attrs: {
            type: "is-primary is-light",
            label: "O score de crédito é uma pontuação para avaliar o histórico financeiro do consumidor. Quanto maior a pontuação, melhor a avaliação! Score de 0 a 1000",
            multilined: ""
          }
        }, [_c("b-icon", {
          attrs: {
            size: "is-small",
            icon: "help-circle-outline"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 3732820708)
  }, [_vm._v(" "), _c("b-input", {
    attrs: {
      value: (_vm$personDetailNV36 = _vm.personDetailNV) === null || _vm$personDetailNV36 === void 0 ? void 0 : (_vm$personDetailNV36$ = _vm$personDetailNV36.CADASTRAIS) === null || _vm$personDetailNV36$ === void 0 ? void 0 : _vm$personDetailNV36$.SCORE,
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailPh11 = _vm.personDetailPh) !== null && _vm$personDetailPh11 !== void 0 && (_vm$personDetailPh11$ = _vm$personDetailPh11.CreditScore) !== null && _vm$personDetailPh11$ !== void 0 && _vm$personDetailPh11$.D00 ? _c("b-field", {
    attrs: {
      label: "SCORE PH3A"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v("\n                SCORE (PH3A)\n                "), _c("b-tooltip", {
          attrs: {
            type: "is-primary is-light",
            label: "O score de crédito é uma pontuação para avaliar o histórico financeiro do consumidor. Quanto maior a pontuação, melhor a avaliação! Score de 0 a 1000",
            multilined: ""
          }
        }, [_c("b-icon", {
          attrs: {
            size: "is-small",
            icon: "help-circle-outline"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 3441257506)
  }, [_vm._v(" "), _c("b-input", {
    attrs: {
      value: (_vm$personDetailPh12 = _vm.personDetailPh) === null || _vm$personDetailPh12 === void 0 ? void 0 : (_vm$personDetailPh12$ = _vm$personDetailPh12.CreditScore) === null || _vm$personDetailPh12$ === void 0 ? void 0 : _vm$personDetailPh12$.D00,
      disabled: ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV37 = _vm.personDetailNV) !== null && _vm$personDetailNV37 !== void 0 && (_vm$personDetailNV37$ = _vm$personDetailNV37.CADASTRAIS) !== null && _vm$personDetailNV37$ !== void 0 && _vm$personDetailNV37$.MENSAGEMSCORE ? _c("b-field", {
    attrs: {
      label: "NÍVEL DE RISCO",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: (_vm$personDetailNV38 = _vm.personDetailNV) === null || _vm$personDetailNV38 === void 0 ? void 0 : (_vm$personDetailNV38$ = _vm$personDetailNV38.CADASTRAIS) === null || _vm$personDetailNV38$ === void 0 ? void 0 : _vm$personDetailNV38$.MENSAGEMSCORE,
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV39 = _vm.personDetailNV) !== null && _vm$personDetailNV39 !== void 0 && (_vm$personDetailNV39$ = _vm$personDetailNV39.PERFILCONSUMO) !== null && _vm$personDetailNV39$ !== void 0 && _vm$personDetailNV39$.PROPENSAO_PAGAMENTO ? _c("b-field", {
    attrs: {
      expanded: ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v("\n                PROPENSÃO PAGAMENTO\n                "), _c("b-tooltip", {
          attrs: {
            type: "is-primary is-light",
            label: "Analise de dados que calculam as chances do usuário realizar uma promessa de pagamento, valor de 0 a 1000.",
            multilined: ""
          }
        }, [_c("b-icon", {
          attrs: {
            size: "is-small",
            icon: "help-circle-outline"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 3753600174)
  }, [_vm._v(" "), _c("b-input", {
    attrs: {
      value: (_vm$personDetailNV40 = _vm.personDetailNV) === null || _vm$personDetailNV40 === void 0 ? void 0 : (_vm$personDetailNV40$ = _vm$personDetailNV40.PERFILCONSUMO) === null || _vm$personDetailNV40$ === void 0 ? void 0 : _vm$personDetailNV40$.PROPENSAO_PAGAMENTO,
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV41 = _vm.personDetailNV) !== null && _vm$personDetailNV41 !== void 0 && (_vm$personDetailNV41$ = _vm$personDetailNV41.CADASTRAIS) !== null && _vm$personDetailNV41$ !== void 0 && _vm$personDetailNV41$.DIVIDAATIVADAUNIAO_FLAG_DAU ? _c("b-field", {
    attrs: {
      label: "DIVIDA ATIVA DA UNIÃO",
      expanded: ""
    }
  }, [_c("b-input", {
    attrs: {
      value: ((_vm$personDetailNV42 = _vm.personDetailNV) === null || _vm$personDetailNV42 === void 0 ? void 0 : (_vm$personDetailNV42$ = _vm$personDetailNV42.CADASTRAIS) === null || _vm$personDetailNV42$ === void 0 ? void 0 : _vm$personDetailNV42$.DIVIDAATIVADAUNIAO_FLAG_DAU) === "S" ? "SIM" : "NÃO",
      disabled: ""
    }
  })], 1) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), _vm.hasProfileConsumeData ? _c("b-collapse", {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentPersonalProfile",
      animation: "slide"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn() {
        return [_c("div", {
          staticClass: "panel-heading",
          attrs: {
            role: "button",
            "aria-controls": "contentPersonalProfile"
          }
        }, [_c("strong", [_vm._v("Dados de Perfil de Consumo")])])];
      },
      proxy: true
    }], null, false, 3827901249)
  }, [_vm._v(" "), _c("div", {
    staticClass: "content-data"
  }, [_c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [(_vm$personDetailNV43 = _vm.personDetailNV) !== null && _vm$personDetailNV43 !== void 0 && (_vm$personDetailNV43$ = _vm$personDetailNV43.CADASTRAIS) !== null && _vm$personDetailNV43$ !== void 0 && _vm$personDetailNV43$.PERSONADEMOGRAFICA ? _c("b-field", {
    attrs: {
      expanded: ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v("\n                PERSONA DEMOGRÁFICA\n                "), _c("b-tooltip", {
          attrs: {
            type: "is-primary is-light",
            label: "Informação populacional que leva em conta alguns dados como Idade, sexo, ciclo de vida, renda presumida, ocupação profissional, região em que mora, formação e por aí vai.",
            multilined: ""
          }
        }, [_c("b-icon", {
          attrs: {
            size: "is-small",
            icon: "help-circle-outline"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 3328149751)
  }, [_vm._v(" "), _c("b-input", {
    attrs: {
      value: (_vm$personDetailNV44 = _vm.personDetailNV) === null || _vm$personDetailNV44 === void 0 ? void 0 : (_vm$personDetailNV44$ = _vm$personDetailNV44.CADASTRAIS) === null || _vm$personDetailNV44$ === void 0 ? void 0 : _vm$personDetailNV44$.PERSONADEMOGRAFICA,
      disabled: ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm$personDetailNV45 = _vm.personDetailNV) !== null && _vm$personDetailNV45 !== void 0 && (_vm$personDetailNV45$ = _vm$personDetailNV45.PERFILCONSUMO) !== null && _vm$personDetailNV45$ !== void 0 && _vm$personDetailNV45$.PERSONADIGITAL ? _c("b-field", {
    attrs: {
      expanded: ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v("\n                PERSONA DIGITAL\n                "), _c("b-tooltip", {
          attrs: {
            type: "is-primary is-light",
            label: "Informação do comportamento do usuário no meio digital",
            multilined: ""
          }
        }, [_c("b-icon", {
          attrs: {
            size: "is-small",
            icon: "help-circle-outline"
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 4019605056)
  }, [_vm._v(" "), _c("b-input", {
    attrs: {
      value: (_vm$personDetailNV46 = _vm.personDetailNV) === null || _vm$personDetailNV46 === void 0 ? void 0 : (_vm$personDetailNV46$ = _vm$personDetailNV46.PERFILCONSUMO) === null || _vm$personDetailNV46$ === void 0 ? void 0 : _vm$personDetailNV46$.PERSONADIGITAL,
      disabled: ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c("div", {
    staticClass: "content-profile-interests"
  }, [_c("h2", {
    staticClass: "title"
  }, [_vm._v("Interesses")]), _vm._v(" "), _c("div", {
    staticClass: "list-cards-items"
  }, [_c("div", {
    staticClass: "columns"
  }, _vm._l(_vm.rowOneList, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "column col-card-information",
      class: {
        active: _vm.getValueInterest(item.key) === 1
      }
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c("span", {
      class: "icon eva eva-".concat(item.icon)
    }), _vm._v(" "), _c("span", {
      staticClass: "bol-check"
    })]);
  }), 0), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, _vm._l(_vm.rowTwoList, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "column col-card-information",
      class: {
        active: _vm.getValueInterest(item.key) === 1
      }
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c("span", {
      class: "icon eva eva-".concat(item.icon)
    }), _vm._v(" "), _c("span", {
      staticClass: "bol-check"
    })]);
  }), 0), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, _vm._l(_vm.rowThreeList, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "column col-card-information",
      class: {
        active: _vm.getValueInterest(item.key) === 1
      }
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c("span", {
      class: "icon eva eva-".concat(item.icon)
    }), _vm._v(" "), _c("span", {
      staticClass: "bol-check"
    })]);
  }), 0), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, _vm._l(_vm.rowFourList, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "column col-card-information",
      class: {
        active: _vm.getValueInterest(item.key) === 1
      }
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c("span", {
      class: "icon eva eva-".concat(item.icon)
    }), _vm._v(" "), _c("span", {
      staticClass: "bol-check"
    })]);
  }), 0), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, _vm._l(_vm.rowFiveList, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "column col-card-information",
      class: {
        active: _vm.getValueInterest(item.key) === 1
      }
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c("span", {
      class: "icon eva eva-".concat(item.icon)
    }), _vm._v(" "), _c("span", {
      staticClass: "bol-check"
    })]);
  }), 0)])])], 1)]) : _vm._e(), _vm._v(" "), _vm.sociedades.length ? _c("b-collapse", {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentPersonalCorporate",
      animation: "slide"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn() {
        return [_c("div", {
          staticClass: "panel-heading",
          attrs: {
            role: "button",
            "aria-controls": "contentPersonalCorporate"
          }
        }, [_c("strong", [_vm._v("Participação Societaria")])])];
      },
      proxy: true
    }], null, false, 3546429508)
  }, [_vm._v(" "), _c("div", {
    staticClass: "content-data"
  }, [_c("b-field", {
    staticClass: "divider",
    attrs: {
      label: "Dados NovaVida:"
    }
  }), _vm._v(" "), _vm._l(_vm.sociedades.slice(0, 3), function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "content-address"
    }, [item.CNPJ ? _c("div", [_c("b-field", {
      attrs: {
        grouped: ""
      }
    }, [_c("b-field", {
      attrs: {
        label: "CNPJ"
      }
    }, [_c("b-input", {
      attrs: {
        value: _vm._f("maskCNPJ")(item.CNPJ),
        disabled: ""
      }
    })], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "RAZÃO SOCIAL",
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: item.RAZAO,
        disabled: ""
      }
    })], 1)], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        grouped: ""
      }
    }, [_c("b-field", {
      attrs: {
        label: "PARTICIPAÇÃO"
      }
    }, [_c("b-input", {
      attrs: {
        value: item.PARTICIPACAO,
        disabled: ""
      }
    })], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "DATA FUNDAÇÃO",
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: _vm._f("dateFormat")(item.DATA_FUNDACAO),
        disabled: ""
      }
    })], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "STATUS RECEITA FEDERAL",
        expanded: ""
      }
    }, [_c("b-input", {
      attrs: {
        value: item.STATUS_RF,
        disabled: ""
      }
    })], 1)], 1)], 1) : _vm._e()]);
  })], 2)]) : _vm._e()], 1), _vm._v(" "), _c("div", {
    staticClass: "column col-detail-person is-one-quarter"
  }, [_c("div", {
    staticClass: "list-col-card-detail"
  }, [_c("div", {
    staticClass: "col-header-content"
  }, [_vm.personDetail.imageBase64 ? _c("img", {
    staticClass: "user-img",
    attrs: {
      src: _vm.userImg
    }
  }) : _vm._e(), _vm._v(" "), _vm.personDetail.liveness ? _c("h4", [_vm._v("Score da Imagem: " + _vm._s(_vm.personDetail.liveness.score) + " de 100")]) : _vm._e(), _vm._v(" "), _c("h4", [_vm._v("CPF: " + _vm._s(_vm._f("maskCPF")(_vm.personDetail.document)))]), _vm._v(" "), (_vm$personDetailPh13 = _vm.personDetailPh) !== null && _vm$personDetailPh13 !== void 0 && _vm$personDetailPh13.Name ? _c("h2", [_vm._v(_vm._s(_vm.personDetailPh.Name))]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "col-content-section"
  }, [_c("div", {
    staticClass: "field"
  }, [(_vm$personDetailPh14 = _vm.personDetailPh) !== null && _vm$personDetailPh14 !== void 0 && (_vm$personDetailPh14$ = _vm$personDetailPh14.Person) !== null && _vm$personDetailPh14$ !== void 0 && _vm$personDetailPh14$.MotherName ? [_c("label", [_vm._v("Nome da mãe")]), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.personDetailPh.Person.MotherName))])] : _vm._e()], 2), _vm._v(" "), _c("div", {
    staticClass: "field"
  }, [(_vm$personDetailPh15 = _vm.personDetailPh) !== null && _vm$personDetailPh15 !== void 0 && _vm$personDetailPh15.BirthDate ? [_c("label", [_vm._v("Data de nascimento")]), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm._f("dateFormat")((_vm$personDetailPh16 = _vm.personDetailPh) === null || _vm$personDetailPh16 === void 0 ? void 0 : _vm$personDetailPh16.BirthDate)))])] : _vm._e()], 2), _vm._v(" "), _c("div", {
    staticClass: "field"
  }, [(_vm$personDetailPh17 = _vm.personDetailPh) !== null && _vm$personDetailPh17 !== void 0 && _vm$personDetailPh17.Age ? [_c("label", [_vm._v("Idade")]), _vm._v(" "), _c("p", [_vm._v("\n                " + _vm._s("".concat((_vm$personDetailPh18 = _vm.personDetailPh) === null || _vm$personDetailPh18 === void 0 ? void 0 : _vm$personDetailPh18.Age, " anos")) + "\n              ")])] : _vm._e()], 2), _vm._v(" "), _c("div", {
    staticClass: "field"
  }, [(_vm$personDetailNV47 = _vm.personDetailNV) !== null && _vm$personDetailNV47 !== void 0 && (_vm$personDetailNV47$ = _vm$personDetailNV47.CADASTRAIS) !== null && _vm$personDetailNV47$ !== void 0 && _vm$personDetailNV47$.SEXO ? [_c("label", [_vm._v("Gênero")]), _vm._v(" "), _c("p", [_vm._v(_vm._s((_vm$personDetailNV48 = _vm.personDetailNV) === null || _vm$personDetailNV48 === void 0 ? void 0 : (_vm$personDetailNV48$ = _vm$personDetailNV48.CADASTRAIS) === null || _vm$personDetailNV48$ === void 0 ? void 0 : _vm$personDetailNV48$.SEXO))])] : _vm._e()], 2), _vm._v(" "), _c("div", {
    staticClass: "field"
  }, [(_vm$personDetailNV49 = _vm.personDetailNV) !== null && _vm$personDetailNV49 !== void 0 && (_vm$personDetailNV49$ = _vm$personDetailNV49.CADASTRAIS) !== null && _vm$personDetailNV49$ !== void 0 && _vm$personDetailNV49$.NACIONALIDADE ? [_c("label", [_vm._v("País")]), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.personDetailNV.CADASTRAIS.NACIONALIDADE))])] : _vm._e()], 2), _vm._v(" "), _c("div", {
    staticClass: "field"
  }, [(_vm$personDetailNV50 = _vm.personDetailNV) !== null && _vm$personDetailNV50 !== void 0 && (_vm$personDetailNV50$ = _vm$personDetailNV50.CADASTRAIS) !== null && _vm$personDetailNV50$ !== void 0 && _vm$personDetailNV50$.POSSIVELESCOLARIDADE ? [_c("label", [_vm._v("Escolaridade")]), _vm._v(" "), _c("p", [_vm._v(_vm._s((_vm$personDetailNV51 = _vm.personDetailNV) === null || _vm$personDetailNV51 === void 0 ? void 0 : (_vm$personDetailNV51$ = _vm$personDetailNV51.CADASTRAIS) === null || _vm$personDetailNV51$ === void 0 ? void 0 : _vm$personDetailNV51$.POSSIVELESCOLARIDADE))])] : _vm._e()], 2), _vm._v(" "), _c("div", {
    staticClass: "field"
  }, [(_vm$personDetailArPn3 = _vm.personDetailArPn) !== null && _vm$personDetailArPn3 !== void 0 && _vm$personDetailArPn3.status ? [_c("label", [_vm._v("Indicação de óbito")]), _vm._v(" "), _c("p", [_vm._v("\n                " + _vm._s(((_vm$personDetailArPn4 = _vm.personDetailArPn) === null || _vm$personDetailArPn4 === void 0 ? void 0 : _vm$personDetailArPn4.status) === "vivo" ? "NÃO" : "SIM") + "\n              ")])] : _vm._e()], 2)])])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;